import React from 'react';

import {
  errorUtil,
  fields,
  formUtil
} from 'iron-forge-react-modules';

import { BaseTier1ReturnAuthorizationModal } from 'modules/layer01';
import { useForm } from 'react-hook-form';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  returnAuthorizationId: string;

  onClose: () => void;
  onFinish: () => void;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);
  const [
    triageReturnAuthorization,
    triageReturnAuthorizationTuple
  ] = dataService.useTriageTier1ReturnAuthorization(props.returnAuthorizationId, queryTuple.data.triageWorkflowId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      serialNumber: ''
    }
  });
  formUtil.useSetFormFields(queryTuple, form.setValue, ['serialNumber']);

  const processSubmit = React.useCallback(
    () => {
      props.onFinish();
      errorUtil.errorWrap(async () => {
        await triageReturnAuthorization();
      });
    },
    [
      props,
      triageReturnAuthorization
    ]
  );

  const loading = queryTuple.loading || triageReturnAuthorizationTuple.loading;
  return (
    <BaseTier1ReturnAuthorizationModal.FC
      title="Scrap Product"
      primaryText="Review and confirm to scrap the product"
      secondaryText="Review the item before proceeding"
      disableButtons={loading}
      onClose={props.onClose}
      onSubmit={form.handleSubmit(processSubmit)}>
      <ControlledTextField
        isRequired
        isDisabled
        label="IMEI/ICCID"
        placeholder="Scan or Select Restock SKU"
        fieldKey="serialNumber"
        formControl={form.control} />
    </BaseTier1ReturnAuthorizationModal.FC>
  );
};
